import React from 'react';
import { Table, } from 'react-bootstrap';
import moment from 'moment-timezone';
import IconAlert from 'components/common/IconAlert';

const OneDPSParties = ({
    parties,
}) => {
    return (<>
        <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-primary"}>
            <center><h5 className='text-primary mb-2'>Dispositif retenu</h5></center>

            {parties.filter(part => part.effectifIsNecessairePartie + part.effectifCmdLogNecessairePartie > 0).length > 0 ?
                <>
                    <div className='d-none d-md-block'>
                        <Table bordered size='sm'>
                            <tr key={'entete'}>
                                <th><center>Début</center></th>
                                <th><center>Fin</center></th>
                                <th><center>Effectif</center></th>
                            </tr>
                            {parties.map((partie, i)=>{return(
                                <tr key={'partie'+i}>
                                    <td><center>{moment(partie.debutPartie).format('DD/MM/YYYY HH:mm')}</center></td>
                                    <td><center>{moment(partie.finPartie).format('DD/MM/YYYY HH:mm')}</center></td>
                                    <td><center>
                                        Intervenants secouriste: {partie.effectifIsNecessairePartie}<br/>
                                        Effectif commandement et logistique: {partie.effectifCmdLogNecessairePartie}
                                    </center></td>
                                </tr>
                            )})}
                        </Table>
                    </div>
                    
                    <div className='d-block d-md-none'>
                        <Table bordered size='sm'>
                            {parties.map((partie, i)=>{return(
                                <tr key={'partie'+i}>
                                    <td>
                                        <h6><center>Partie #{i+1}</center></h6>
                                        Début: {moment(partie.debutPartie).format('DD/MM/YYYY HH:mm')}<br/>
                                        Fin: {moment(partie.finPartie).format('DD/MM/YYYY HH:mm')} <br/>
                                        Intervenants secouriste: {partie.effectifIsNecessairePartie}<br/>
                                        Commandement/logistique: {partie.effectifCmdLogNecessairePartie}
                                    </td>
                                </tr>
                            )})}
                        </Table>
                    </div>
                </>
            :
                <IconAlert variant={'info'} >Votre dispositif n'est pas encore totalement conçu, le détail sera disponible prochainement</IconAlert>
            }

        </div>
    </>);
    
};

OneDPSParties.propTypes = {};

export default OneDPSParties;
